import React from 'react';
import PropTypes from 'prop-types';
import { Div, Image, Loader, Text } from '@pinpoint/design-kit';

import Button from 'src/components/button';

/**
 * LoaderComponent - Loader animation
 *
 * @param {object} props
 * @param {string} [props.type = '']
 * @param {string} [props.text = '']
 * @param {object} [props.cta = null]
 * @param {React.ReactNode} [props.children]
 * @param {object} [props.rest] - pass through props
 * @returns {React.JSX.Element}
 */
function LoaderComponent({ type, text, cta, children, ...rest }) {
  return (
    <Div pos="absolute" top="50%" left="50%" transform="translate(-50%, -50%)" {...rest}>
      <Div flexDir="column" d="flex" justify="center" align="center">
        {(() => {
          switch (type) {
            case 'warning':
              return <Image w="512px" src="/static/warning.svg" />;
            case 'error':
              return <Image w="512px" src="/static/error.svg" />;
            case 'info':
              return <Image w="256px" src="/static/info.svg" />;
            case 'analysis':
              return <Image w="512px" src="/static/analysis.svg" />;
            default:
              return <Loader />;
          }
        })()}
        {text ? (
          <Text m={{ y: '1rem' }}>{text}</Text>
        ) : type === 'error' ? (
          <Text m={{ y: '1rem' }}>
            There seems to be a problem in serving your request. Can you please try again? If the problem persists
            contact support@pinpoint.ai
          </Text>
        ) : null}
        {cta ? (
          <Button buttonStyle="primary" onClick={() => cta.onClick()}>
            {cta.text}
          </Button>
        ) : null}
        {children}
      </Div>
    </Div>
  );
}

LoaderComponent.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  cta: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

LoaderComponent.defaultProps = {
  type: '',
  text: '',
  cta: null,
  children: null,
};

export default LoaderComponent;
